import React from 'react'

import { TextFormatter } from './formatter'
import { useText, TextGetProps } from './hook'

export interface TextRenderProps {
  ref: React.RefCallback<HTMLInputElement>
  value: string
  getProps: () => TextGetProps
}

export interface TextProps {
  children: (props: TextRenderProps) => React.ReactElement | null
  value?: string
  formatters: Array<TextFormatter>
}

const Text = React.memo(({ children, value = '', formatters }: TextProps) => {
  const {
    ref,
    value: returnValue,
    getProps,
  } = useText({
    value,
    formatters,
  })

  return children({
    ref,
    value: returnValue,
    getProps,
  })
})

Text.displayName = 'Text'

export { Text }
